export default "__VITE_ASSET__BbjZFMut__"